import React from 'react';
import moment from 'moment';

export default class CustomDateFieldTransformer {
    transform(value) {
        if (!value) {
            return null;
        }

        // Apply custom date format, for example 'DD.MM.YYYY'
        const formattedDate = moment(value).format('DD.MM.YYYY');

        return <span>{formattedDate}</span>;
    }
}
